import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 数据源
import { Store, ListStore } from './store';
// 组件
import Wrap from './component/Wrap';
import Header from './component/Header';
import Main from './component/Main';
import Brand from './component/Brand';
// 全局变量
import { LINK_URL } from '@src/constants';
// 方法
import { getQuery } from '@src/utils/url';
import { getGv } from '@src/utils/app';
import { isIOS } from '@src/utils';
// 新版Grounds
import { Grounds } from '@ifeng-fe/client_grounds';
import vConsole from '@src/utils/vConsole';
vConsole();

const Layout = ({ content }) => {
    const { dramaSeries } = content;
    const [isShow, setIsShow] = useState(true);

    useEffect(() => {
        // 端内阻止iOS浏览器自带下拉刷新
        Grounds.disableBounceEffect('close');
    }, []);

    const val = {
        link: {
            type: 'web', // 链接的类型
            url: `${LINK_URL}`, // 链接的地址:首页
        },
    };

    // 动态html更改标题
    useEffect(() => {
        document.title = dramaSeries.title;
    }, []);
    // 当前页面销毁后执行的跳转操作
    useEffect(() => {
        const backIndex = getQuery(window.location.href, 'backIndex');
        const version = getGv();

        if (isIOS() && version < '7.52.1') {
            return;
        }

        if (window.grounds && backIndex) {
            Grounds.configBackUrl(val);
        }
    }, []);

    // 7430 / 以下直接展示升级页面;
    useEffect(() => {
        if (window.grounds) {
            const version = getGv();

            if (version < '7.43.0') {
                setIsShow(false);

                const option = {
                    type: 'other',
                    url: 'xxx',
                };

                // 拉起更新页面
                if (isIOS()) {
                    Grounds.close();
                    Grounds.dispatch(option);
                } else {
                    Grounds.dispatch(option);

                    setTimeout(() => {
                        Grounds.close();
                    }, 500);
                }
            }
        }
    }, []);

    return (
        <ListStore.Provider>
            <Store.Provider>
                {isShow ? (
                    <Wrap content={content}>
                        {/* 端外分享 */}
                        <Brand />
                        {/* 视频 */}
                        <Header content={content} />
                        {/* 主体 */}
                        <Main content={content} />
                    </Wrap>
                ) : null}
            </Store.Provider>
        </ListStore.Provider>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
